export default __webpack_public_path__ + "static/media/meg.42e3042e.jpg";